import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
const EmployeeRoster = React.lazy(() => import('./employee-roster/CreateRoaster'));
const ManagerRoster = React.lazy(() => import('./manager-roster/CreateRoaster'));
const CorporateRoster = React.lazy(() => import('./corporate-roster/CreateRoaster'));
const RosterSettingList = React.lazy(() => import('./Roster-Settings/listing'));

export const rosterConfigs = [
  {
    permittedRole: RoutePermittedRole.employee,
    path: '/rosters/my-roster-request',
    element: <EmployeeRoster />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/roster-setting-list',
    element: <RosterSettingList />,
  },
  {
    permittedRole: RoutePermittedRole.manager,
    path: '/rosters/roster-creation',
    element: <ManagerRoster />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/rosters/roster-page',
    element: <CorporateRoster />,
  },

];
